/**
 * Azure AD SAML via api-gateway (SP). User is redirected to GET /api/v1/users/saml/login;
 * IdP POSTs back to the gateway ACS, then the gateway redirects to SAML_APP_SUCCESS_URL.
 */

export const VALID_SAML_PROFILES = ["heco", "heco2"];
export const DEFAULT_SAML_PROFILE = "heco";

/** Strip stray quotes from env vars (docker-compose default used to inject 'http://...'). */
const normalizeApiBaseUrl = (raw) => {
  let url = (raw || "").trim();
  if (
    (url.startsWith("'") && url.endsWith("'")) ||
    (url.startsWith('"') && url.endsWith('"'))
  ) {
    url = url.slice(1, -1).trim();
  }
  return url.replace(/\/+$/, "");
};

export function isAzureSamlSsoConfigured() {
  const raw = (process.env.REACT_APP_AZURE_SAML_SSO_ENABLED || "").trim().toLowerCase();
  if (raw === "false" || raw === "0") {
    return false;
  }
  return (raw === "true" || raw === "1") && Boolean(normalizeApiBaseUrl(process.env.REACT_APP_API_URL));
}

/** Raw ?saml= value, or null when the query param is absent. */
export function getRawSamlQueryParam() {
  if (typeof window === "undefined") {
    return null;
  }
  const params = new URLSearchParams(window.location.search);
  if (!params.has("saml")) {
    return null;
  }
  return (params.get("saml") || "").trim();
}

/**
 * Gateway profile key from ?saml=heco | ?saml=heco2. Any other ?saml= value falls back to heco.
 */
export function getSamlProfileFromLoginPageUrl() {
  const raw = getRawSamlQueryParam();
  if (raw === null) {
    return "";
  }
  if (VALID_SAML_PROFILES.includes(raw)) {
    return raw;
  }
  return DEFAULT_SAML_PROFILE;
}

/** True when ?saml= is present (any value). */
export function isSamlLoginRoute() {
  return getRawSamlQueryParam() !== null;
}

/** Show SAML button when ?saml= is present (invalid values use heco). */
export function shouldShowSamlLoginButton() {
  return isAzureSamlSsoConfigured() && isSamlLoginRoute();
}

/** Show Microsoft OIDC button when ?saml= is absent. */
export function shouldShowOidcLoginButton() {
  return !isSamlLoginRoute();
}

/** @deprecated use isAzureSamlSsoConfigured */
export function isAzureSamlSsoEnabled() {
  return isAzureSamlSsoConfigured();
}

/** Full URL to start SP-initiated SAML (same host as API session cookie). */
export function getAzureSamlLoginUrl() {
  const base = normalizeApiBaseUrl(process.env.REACT_APP_API_URL);
  if (!base) {
    throw new Error("REACT_APP_API_URL is not configured");
  }
  const profile = getSamlProfileFromLoginPageUrl();
  if (!profile) {
    throw new Error("SAML login requires ?saml= in the URL");
  }
  return `${base}/api/v1/users/saml/login?app=${encodeURIComponent(profile)}`;
}
